"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxTokenAmount = void 0;
/* eslint-disable import/prefer-default-export */
exports.maxTokenAmount = "9223372036854775807";
